module.exports = __webpack_public_path__ + "img/head.1291ddc8.jpg";